import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconX: OSKIconDefinition = {
  name: 'x',
  content: '<path d="M18 6 6 18M6 6l12 12" />'
};
